<template>
  <section class="home-how-it-work-container">
    <div class="home-how-it-work-section">
      <div class="container">
        <div class="text-content">
          <h3>{{ $t('home.how.it.work.headline') }}</h3>
          <p class="p1">{{ $t('home.how.it.work.paragraph-1') }}</p>
          <p class="p1">{{ $t('home.how.it.work.paragraph-2') }}</p>
          <p class="p2">{{ $t('home.how.it.work.paragraph-3') }}</p>
          <p class="p2">{{ $t('home.how.it.work.paragraph-4') }}</p>
          <p class="p2">{{ $t('home.how.it.work.paragraph-5') }}</p>
        </div>
        <img src="/img/home/diagram.svg" :alt="$t('home.diagram')" />
      </div>
      <join-us-button />
    </div>
  </section>
</template>

<script>
import JoinUsButton from '@/components/common/JoinUsButton.vue';

export default {
  components: {
    JoinUsButton,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors';
@import '~@/assets/styles/variables';
@import '~@/assets/styles/breakpoints';

.home-how-it-work-container {
  width: 100%;
  background: $light-grey;
  display: flex;
  justify-content: center;
  padding: 70px 0;
  margin-bottom: 50px;
}

.home-how-it-work-section {
  max-width: $page-laptop-breakpoint;
}

.container {
  display: flex;
}

.text-content {
  margin-right: 30px;
}

img {
  max-width: 100%;
}

h3,
p {
  padding-bottom: 20px;
  max-width: 395px;
}

.p1 {
  color: $grey;
}

.p2 {
  font-weight: bold;
}

p:last-of-type {
  padding-bottom: 60px;
}

@media (max-width: $page-laptop-breakpoint) {
  .home-how-it-work-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: $page-table-breakpoint;
  }

  h3,
  p {
    max-width: $page-table-breakpoint;
  }

  .home-how-it-work-container {
    margin-bottom: 100px;
  }

  .container {
    flex-direction: column;
    align-items: center;
  }

  .text-content {
    text-align: center;
    margin-right: 0;
  }

  img {
    margin-bottom: 50px;
  }
}

@media (max-width: $page-table-breakpoint) {
  .home-how-it-work-container {
    padding: 45px 0;
    margin-bottom: 75px;
  }

  .home-how-it-work-section {
    max-width: $page-mobile-large-breakpoint;
    padding: 0 10px;
  }

  p {
    padding-bottom: 10px;
  }
}

@media (max-width: $page-mobile-large-breakpoint) {
  .home-how-it-work-container {
    padding: 20px 0;
    margin-bottom: 50px;
  }

  .home-how-it-work-section {
    max-width: $page-mobile-small-breakpoint;
  }
}
</style>
